import { ApiFetcher } from 'api-fetcher-treeline/dist';

const eventsApi = new ApiFetcher(`${process.env.REACT_APP_EVENTS_API_URL}`);

export default eventsApi;
